import {ApplicationConfig, provideZoneChangeDetection} from '@angular/core';
import {provideRouter} from '@angular/router';
import {routes} from './app.routes';
import {provideHttpClient, withFetch, withInterceptorsFromDi} from "@angular/common/http";
import {provideAnimationsAsync} from "@angular/platform-browser/animations/async";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {RequestInterceptor} from "./utils-lib/requestInterceptor";
import { provideMarkdown } from 'ngx-markdown';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeng/themes/lara';

const httpInterceptorProviders = [{ provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true }];

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideMarkdown(),
    providePrimeNG({
      theme: {
        preset: Lara
      }
    }),
    { provide: MAT_DIALOG_DATA, useValue: {}},
    httpInterceptorProviders
  ]
};
